import React from "react";
import {
  cn,
  getFocusRingStyles,
  getBorderStyles,
  getBackgroundStyles,
  getForegroundStyles,
  getDisabledStyles,
} from "../../styles";
import { PanelColor, ThemeColor } from "../../props";

export interface ButtonControlProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  readOnly?: boolean;
  error?: boolean;
  dense?: boolean;
  color?: PanelColor;
  className?: string;
}

export const ButtonControl = ({
  children,
  onClick,
  disabled,
  readOnly,
  error,
  dense,
  color = PanelColor.level0,
  className,
}: ButtonControlProps) => {
  return (
    <button
      type="button"
      onClick={disabled || readOnly ? undefined : onClick}
      disabled={disabled}
      className={cn(
        "relative w-full text-left",
        "rounded-md border",
        dense ? "rounded" : "rounded-md",
        "outline-none focus-visible:ring-2",
        error
          ? getFocusRingStyles(ThemeColor.error)
          : getFocusRingStyles(ThemeColor.primary),
        getBackgroundStyles(color),
        getBorderStyles(error ? ThemeColor.error : ThemeColor.gray),
        getForegroundStyles(color),
        disabled ? getDisabledStyles() : readOnly ? "pointer-events-none cursor-default" : "cursor-pointer",
        className,
      )}
    >
      {children}
    </button>
  );
};

ButtonControl.displayName = "ButtonControl";
